// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2O9RE","footer":"ModalInfo_footer__153RG"};